export default __webpack_public_path__ + "static/media/bg31.9368ff09.jpg";